import axiosInstance from "../helpers/axiosInstance";

export const getQutationApi = async (request) => {
    const url = `staff/quotation/v2`;
    const response = await axiosInstance.post(url, request.data);
    return response.data;
};

export const getWorkspaceApi = async (request) => {
    const url = `staff/quotation/workSpace`;
    const response = await axiosInstance.post(url, request.data);
    return response.data;
};

export const getQuotationByIdApi = async (quotationId) => {
    const url = `staff/quotations/${quotationId}`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const getIgnoreFieldsApi = async (quotationId) => {
    const url = `staff/quotation/ignoredFields/${quotationId}`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const cloneQuotationApi = async (quotationId, status) => {
    const url = `staff/quotations/${quotationId}/clone?revised=${status}`;
    const response = await axiosInstance.post(url);
    return response.data;
};

export const cloneLocationApi = async (id) => {
    const url = `staff/quotationLocation/${id}/clone`;
    const response = await axiosInstance.post(url);
    return response.data;
};

export const cloneGroupApi = async (request) => {
    const url = `staff/quotationGroup/clone`;
    const response = await axiosInstance.post(url, request.formData);
    return response.data;
};

export const getQuotationTemplatesApi = async () => {
    const response = await axiosInstance.get("staff/templates");
    return response.data
};

export const createQuotationApi = async (request) => {
    const CREATE_QUTATION = `staff/quotations`;
    const response = await axiosInstance.post(CREATE_QUTATION, request.formData);
    return response.data
};

export const updateQuotationApi = async (request) => {
    const UPDATE_QUTATION = `staff/quotations`;
    const response = await axiosInstance.put(UPDATE_QUTATION, request.formData);
    return response.data
};

export const getQutationGroupsApi = async (quotationId, isWorkspace) => {
    const GROUP_LIST = `staff/quotations/${quotationId}/quotationGroups?workSpace=${isWorkspace}`;
    const response = await axiosInstance.get(GROUP_LIST);
    return response.data
};

export const deleteQuotationApi = async (quotationId) => {
    const GROUP_LIST = `staff/quotations/${quotationId}`;
    const response = await axiosInstance.delete(GROUP_LIST);
    return response.data
};

export const createQuotationGroupsApi = async (request) => {
    const CREATE_GROUPS = `staff/quotationGroups`;
    const response = await axiosInstance.post(CREATE_GROUPS, request.formData);
    return response.data
};

export const updateQuotationGroupsApi = async (request) => {
    const UPDATE_GROUPS = `staff/quotationGroups`;
    const response = await axiosInstance.put(UPDATE_GROUPS, request.formData);
    return response.data
};

export const deleteQutationGroupsApi = async (groupId) => {
    const GROUP_DELETE = `staff/quotationGroups/${groupId}`;
    const response = await axiosInstance.delete(GROUP_DELETE);
    return response.data
};

export const createFooterGroupsApi = async (request) => {
    const CREATE_GROUPS = `staff/quotations/footer`;
    const response = await axiosInstance.post(CREATE_GROUPS, request.formData);
    return response.data
};

export const addTermsGroupsApi = async (request) => {
    const CREATE_GROUPS = `staff/quotations/${request.quotationId}/termsAndConditions`;
    const response = await axiosInstance.put(CREATE_GROUPS, request.formData, {
        headers: { 'Content-Type': 'text/plain; charset=utf-8' }
    });
    return response.data
};

export const getExecutivesApi = async () => {
    const response = await axiosInstance.get("staff/dropdown/salesExecutives");
    return response.data
};

export const addSalesExecutiveApi = async (request) => {
    const CREATE_GROUPS = `staff/quotations/${request.quotationId}/salesExecutive/${request.formData.salesExecutiveId}`;
    const response = await axiosInstance.post(CREATE_GROUPS, request.formData);
    return response.data
};

export const previewQuotationApi = async (request) => {
    const workSpace = request.isPreview === true ? true : false;
    const PREVIEW_QUOTATION = `public/quotations/${request.quotationId}/html?workSpace=${workSpace}`;
    return axiosInstance.get(PREVIEW_QUOTATION, { responseType: 'text' })
        .then((response) => response.data)
        .catch((error) => {
            console.error(error);
        });
};

export const generateQuotationApi = async (request) => {
    const GENERATE_QUOTATION = `staff/quotations/${request.quotationId}/generate`;
    const response = await axiosInstance.get(GENERATE_QUOTATION);
    return response.data
};

export const getLocationsOfQuotationsApi = async (quotationId, isWorkspace) => {
    const LOCATIONS = `staff/quotations/${quotationId}/quotationLocations?workSpace=${isWorkspace}`;
    const response = await axiosInstance.get(LOCATIONS);
    return response.data
};

export const getQuotationStatusApi = async () => {
    const STATUS = `public/dropdown/quotationStatus`;
    const response = await axiosInstance.get(STATUS);
    return response.data
};

export const updateQuotationStatusApi = async (quotationId, status) => {
    const STATUS = `staff/quotations/${Number(quotationId)}/status/${Number(status)}`;
    const response = await axiosInstance.put(STATUS);
    return response.data
};

export const addLocationToQuotationApi = async (request) => {
    const ADD_LOCATION = `staff/quotationLocations`;
    const response = await axiosInstance.post(ADD_LOCATION, request.formData);
    return response.data
};

export const editLocationToQuotationApi = async (request) => {
    const EDIT_LOCATION = `staff/quotationLocations`;
    const response = await axiosInstance.put(EDIT_LOCATION, request.formData);
    return response.data
};

export const deleteLocationToQuotationApi = async (request) => {
    const DELETE_LOCATION = `staff/quotationLocations/${request.deleteId}`;
    const response = await axiosInstance.delete(DELETE_LOCATION);
    return response.data
};

export const getFooterOfQuotationsApi = async (quotationId) => {
    const FOOTER = `staff/quotations/${quotationId}/footer/v2`;
    const response = await axiosInstance.get(FOOTER);
    return response.data
};

export const editFooterToQuotationApi = async (request) => {
    const EDIT_LOCATION = `staff/quotations/footer`;
    const response = await axiosInstance.put(EDIT_LOCATION, request.formData);
    return response.data
};

export const addIgnoreFieldsApi = async (request) => {
    const IGNORE = `staff/quotation/ignoredFields`;
    const response = await axiosInstance.put(IGNORE, request.formData);
    return response.data
};

export const getQuotationProductsApi = async (groupId) => {
    const PRODUCTS = `staff/quotations/groups/${groupId}/products`;
    const response = await axiosInstance.get(PRODUCTS);
    return response.data
};

export const addQuotationProductApi = async (request) => {
    const ADD_PRODUCT = `staff/quotationGroups/products`;
    const response = await axiosInstance.post(ADD_PRODUCT, request.formData);
    return response.data
};

export const addQuotationMergeProductApi = async (request) => {
    const ADD_PRODUCT = `staff/quotationGroups/products/workspace`;
    const response = await axiosInstance.post(ADD_PRODUCT, request.formData);
    return response.data
};

export const editQuotationMergeProductApi = async (request) => {
    const EDIT_PRODUCT = `staff/quotationGroups/products/workspace`;
    const response = await axiosInstance.put(EDIT_PRODUCT, request.formData);
    return response.data
};

export const deleteQuotationProductApi = async (request) => {
    const DELETE_PRODUCT = `staff/quotationGroups/products/${request}`;
    // Axios doesn't support a body in DELETE by default — use `data` inside config
    const response = await axiosInstance.delete(DELETE_PRODUCT, { data: request.formData });
    return response.data
};

export const downloadQuotationApi = async (request) => {
    const PREVIEW_QUOTATION = `staff/quotations/${request.quotationId}/preview`;
    const response = await axiosInstance.get(PREVIEW_QUOTATION, { responseType: "blob" });
    return response.data
};

export const newTempFormQuote = async (request) => {
    const NEW_TEMP_FORM = `staff/customProduct`;
    const response = await axiosInstance.post(NEW_TEMP_FORM, request.formData);
    return response.data
};

export const newTempUpdateFormQuote = async (request) => {
    const UPDATENEWFORM = `staff/customProduct`;
    const response = await axiosInstance.put(UPDATENEWFORM, request.formData);
    return response.data
};

export const quotationCsvDownloadApi = async (request) => {
    const CSV_DOWNLOAD = `staff/quotations/${request.id.id}/csv`;
    const response = await axiosInstance.get(CSV_DOWNLOAD, { responseType: 'text' });
    return response.data
};

export const newTempDeleteTeable = async (id1, id2, id3) => {
    const DELETE_NEW_TABLE = `staff/customProduct?customProductId=${id1}&quotationId=${id2}&quotationGroupId=${id3}`;
    const response = await axiosInstance.delete(DELETE_NEW_TABLE);
    return response.data
};

export const deleteQuotationMergeProductApi = async (request) => {
    const DELETE_WORKSPACE_PRODUCT = `staff/quotationGroups/workspace/products/${request}`;
    const response = await axiosInstance.delete(DELETE_WORKSPACE_PRODUCT, { data: request.formData });
    return response.data
};

export const addQuotationMergeGroupApi = async (request) => {
    const ADD_GROUP = `staff/quotation-groups/merge`;
    const response = await axiosInstance.post(ADD_GROUP, request.formData);
    return response.data
};

export const editQuotationMergeGroupApi = async (request) => {
    const EDIT_GROUP = `staff/quotation-groups/merge`;
    const response = await axiosInstance.put(EDIT_GROUP, request.formData);
    return response.data
};

export const createMergeGroupApi = async (request) => {
    const response = await axiosInstance.post(`staff/quotation-groups/merge`, request.formData);
    return response.data
};

export const editMergeGroupApi = async (request) => {
    const response = await axiosInstance.put(`staff/quotation-groups/merge`, request.formData);
    return response.data
};

export const deleteMergeGroupApi = async (mergedGroupId) => {
    const response = await axiosInstance.delete(`staff/quotation-groups/merge/${mergedGroupId}`);
    return response.data
};

export const cloneMergeGroupApi = async (request) => {
    const response = await axiosInstance.post(`staff/quotation-groups/merge/clone`, request.formData);
    return response.data
};